module.exports = __webpack_public_path__ + "img/2_151.bd1f1814.png";